import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/admin/admin-settings",
      },
      queries: [],
    }),
    [],
  );
}

export const useAdminSettingsIndexPageNavigator = createPageNavigator<void>({
  useNavigator,
});
